import { Route, Routes, useParams } from 'react-router-dom';

import { paths, routes } from 'data/routes';

import { Manage } from 'sections/Manage';

import { Table } from 'components/Table';
import { useZones } from './useZones';
import * as S from '../../../Budget/components/List/List.styles';

export const Zones = () => {
  const params = Object.values(useParams());
  const hasNew = params.includes('new');
  const hasEdit = params.includes('edit');
  const { zonesColumns, zonesTab, zones } = useZones();

  return (
    <div>
      {!hasNew && !hasEdit && (
        <S.CreateWrapper>
          <S.Create
            fontFamily="LFT Zeno Condensed"
            iconLeft="FiPlus"
            scale="lg"
            asLink
            to={`${routes.zones + routes.add}`}
            motive="addNew"
            textTransform="uppercase"
          >
            Add new Zone
          </S.Create>
        </S.CreateWrapper>
      )}
      <Routes>
        <Route
          index
          element={
            <Table columns={zonesColumns} data={zones} hasPagination autoResetPage />
          }
        />
        <Route path={paths.add} element={<Manage title="Add new zone" tabs={zonesTab} />} />
        <Route path={paths.edit} element={<Manage title="Edit zone" tabs={zonesTab} />} />
      </Routes>
    </div>
  );
};
